import { Colors, FlexBox } from "@brg/ui"
import styled, { css } from "styled-components"
import { LayoutConst } from "../../../../../core";
import { InfoItem } from "./components/InfoItem";

export const InfoItemWrapper = styled(FlexBox)<{ isActive: boolean }>`
  flex-flow: column;
  text-overflow: ellipsis;
  overflow: hidden;
  transition: color 0.2s, font-weight 0.2s;
  ${({ isActive, theme }) => isActive && css`
    color: ${theme.viewType.item.active || (theme.themeName === 'whiteTheme' ? '#151514' : '#fff')} !important;
    font-weight: bold !important;
  `};
`;

export const DropdownContainer = styled.div<{ visible: boolean }>`
  background: ${({ theme }) => theme.landing_nav.bg};
  min-height: 49px;
  max-height: ${({ visible }) => visible ? '417px' : '49px'};
  height: ${({ visible }) => visible ? '417px' : '49px'};
  border-radius: 3px;
  width: 280px;
  &::-webkit-scrollbar {
          height: 1px;
          width: 2px;
        }
        &::-webkit-scrollbar-track {
          border-radius: 10px;
          background: ${({theme}) => theme.competition.input.bgActive} !important;
        }
        &::-webkit-scrollbar-thumb {
          background: ${({theme}) => theme.competition.input.inputText} !important;
        }

   > div {
      width: 100%;
    }

  .icon-with-text {
    padding-left: 16px;
  }

  .dropdown-list-item {
    width: 100%;
    max-width: 100%;
    user-select: none;
    pointer-events: none;
  }

  .theme-name {
    padding-left: 16px;
    margin-right: 16px;
  }

  a {
    .dropdown-list-item {
      background-color: ${({ theme }) => theme.landing_nav.item.bg};
    }
    &:hover {
      .dropdown-list-item {
        background-color: ${({ theme }) => theme.landing_nav.item.hover} !important;
      }

      .theme-name {
        color: ${({ theme }) => theme.landing_nav.item.hoverColor} !important;
      }
    }
  }



  .dropdown-element-popup {
    visibility: visible;
    display: block;
    background: ${({ theme }) => theme.landing_nav.bg};
    min-width: 280px;

    > div {
      min-width: 280px;
      margin-top: 5px;
    }
  }

  ${({ visible }) => visible ? css`
    .target-icon-wrapper {
      svg {
        transform: rotate(-180deg);
        transition: transform 0.2s;
      }
    ` : css`
      svg {
        transform: rotate(0);
        transition: transform 0.2s;
      }
    }
  `};
`;

export const NavigationList = styled.div<{ containerStyles?: any; hasHeader?: boolean}>`
  margin-top: ${({ hasHeader }) => hasHeader ? '53px' : '14px'};
  margin-left: 16px;
  display: flex;
  row-gap: 16px;
  color: ${({ theme }) => theme.landing_nav.item.color};
  height: auto;
  overflow-y: hidden;
  overflow-x: hidden;
  height: auto;
  width: 280px;
  z-index: 100;
  flex-direction: column;

  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; 
  letter-spacing: -0.02em;

  ${({ containerStyles }) => containerStyles && css`${containerStyles}`}

  @media(max-width: ${LayoutConst.screen.md}px) {
    margin-left: 0;
    margin-right: 16px;
    align-items: flex-end;
  }
  
  @media(max-width: ${LayoutConst.screen.s}px) {
    margin-right: 10px;
  }
  

  * {
  ::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }
  ::-webkit-scrollbar-track {
      background: transparent !important;
  }
  ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: rgba(144, 144, 144, 1);
  }
  }


  .dropdown-element-popup {
    box-shadow: none;
    margin-top: 20px;
    max-height: 350px;
  }

  .icon-with-text {
    font-weight: 600;
    font-size: 20px;
    line-height: 25px;
  }

  .target-icon-wrapper{
    justify-content: space-between;
    height: 49px;
    margin: 0;
    &:hover {
        color: #909090!important;

        .dropdown-header {
            color: #909090!important
        }

        svg path {
            fill: #909090!important;
            stroke: transparent !important;
        }
    }

    svg{
      width: 20px;
      height: 20px;
    }
  }

  .dropdown-list-item {
    padding: 0;
    box-shadow: none;
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    min-height: 20px;
    padding: 8px 0;
    word-break: keep-all;
  }

  .checkbox {
    background-color:${({ theme }) => theme.landing_nav.item.bg};
    padding: 0 0 0 0;
    max-width: 171px;

    div:first-child {
      width: 22px;
      height: 22px;
      min-width: 22px;
      max-height: 22px;
      min-height: 22px;
    }
    
    div {
        font-size: 10px;
        line-height: 13px;
        padding-top: 0;
        font-weight: 400;
    }

    div:last-child {
      margin-left: 35px;
    }
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    .dropdown-list-item {
      font-size: 13px;
      line-height: 16px;
    }
  }
`

export const NavigationListHeader = styled.div`
  font-size: 17px;
  font-weight: 400;
  line-height: 22px; 
`;
import { Colors, FlexBox } from "@brg/ui"
import styled, { css } from "styled-components"
import { LayoutConst } from "../../../../../core";
import { InfoItem } from "./components/InfoItem";

export const InfoItemWrapper = styled(FlexBox)<{ isActive: boolean }>`
  flex-flow: column;
  text-overflow: ellipsis;
  overflow: hidden;
  transition: color 0.2s, font-weight 0.2s;
  ${({ isActive, theme }) => isActive && css`
    color: ${theme.viewType.item.active || (theme.themeName === 'whiteTheme' ? '#151514' : '#fff')} !important;
    font-weight: bold !important;
  `};
`;

export const DropdownContainer = styled.div<{ visible: boolean }>`
  background: ${({ theme }) => theme.landing_nav.bg};
  min-height: 49px;
  max-height: ${({ visible }) => visible ? '417px' : '49px'};
  height: ${({ visible }) => visible ? '417px' : '49px'};
  border-radius: 3px;
  width: 280px;
  &::-webkit-scrollbar {
          height: 1px;
          width: 2px;
        }
        &::-webkit-scrollbar-track {
          border-radius: 10px;
          background: ${({theme}) => theme.competition.input.bgActive} !important;
        }
        &::-webkit-scrollbar-thumb {
          background: ${({theme}) => theme.competition.input.inputText} !important;
        }

   > div {
      width: 100%;
    }

  .icon-with-text {
    padding-left: 16px;
  }

  .dropdown-list-item {
    width: 100%;
    max-width: 100%;
    user-select: none;
    pointer-events: none;
  }

  .theme-name {
    padding-left: 16px;
    margin-right: 16px;
  }

  a {
    .dropdown-list-item {
      background-color: ${({ theme }) => theme.landing_nav.item.bg};
    }
    &:hover {
      .dropdown-list-item {
        background-color: ${({ theme }) => theme.landing_nav.item.hover} !important;
      }

      .theme-name {
        color: ${({ theme }) => theme.landing_nav.item.hoverColor} !important;
      }
    }
  }



  .dropdown-element-popup {
    visibility: visible;
    display: block;
    background: ${({ theme }) => theme.landing_nav.bg};
    min-width: 280px;

    > div {
      min-width: 280px;
      margin-top: 5px;
    }
  }

  ${({ visible }) => visible ? css`
    .target-icon-wrapper {
      svg {
        transform: rotate(-180deg);
        transition: transform 0.2s;
      }
    ` : css`
      svg {
        transform: rotate(0);
        transition: transform 0.2s;
      }
    }
  `};
`;

export const NavigationList = styled.div<{ containerStyles?: any; hasHeader?: boolean}>`
  margin-top: ${({ hasHeader }) => hasHeader ? '53px' : '14px'};
  margin-left: 16px;
  display: flex;
  row-gap: 16px;
  color: ${({ theme }) => theme.landing_nav.item.color};
  height: auto;
  overflow-y: hidden;
  overflow-x: hidden;
  height: auto;
  width: 280px;
  z-index: 100;
  flex-direction: column;

  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; 
  letter-spacing: -0.02em;

  ${({ containerStyles }) => containerStyles && css`${containerStyles}`}

  @media(max-width: ${LayoutConst.screen.md}px) {
    margin-left: 0;
    margin-right: 16px;
    align-items: flex-end;
  }
  
  @media(max-width: ${LayoutConst.screen.s}px) {
    margin-right: 10px;
  }
  

  * {
  ::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }
  ::-webkit-scrollbar-track {
      background: transparent !important;
  }
  ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: rgba(144, 144, 144, 1);
  }
  }


  .dropdown-element-popup {
    box-shadow: none;
    margin-top: 20px;
    max-height: 350px;
  }

  .icon-with-text {
    font-weight: 600;
    font-size: 20px;
    line-height: 25px;
  }

  .target-icon-wrapper{
    justify-content: space-between;
    height: 49px;
    margin: 0;
    &:hover {
        color: #909090!important;

        .dropdown-header {
            color: #909090!important
        }

        svg path {
            fill: #909090!important;
            stroke: transparent !important;
        }
    }

    svg{
      width: 20px;
      height: 20px;
    }
  }

  .dropdown-list-item {
    padding: 0;
    box-shadow: none;
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    min-height: 20px;
    padding: 8px 0;
    word-break: keep-all;
  }

  .checkbox {
    background-color:${({ theme }) => theme.landing_nav.item.bg};
    padding: 0 0 0 0;
    max-width: 171px;

    div:first-child {
      width: 22px;
      height: 22px;
      min-width: 22px;
      max-height: 22px;
      min-height: 22px;
    }
    
    div {
        font-size: 10px;
        line-height: 13px;
        padding-top: 0;
        font-weight: 400;
    }

    div:last-child {
      margin-left: 35px;
    }
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    .dropdown-list-item {
      font-size: 13px;
      line-height: 16px;
    }
  }
`

export const NavigationListHeader = styled.div`
  font-size: 17px;
  font-weight: 400;
  line-height: 22px; 
`;
